namespace GeniuzPOS.InitialData {
    export class PsConnectEdcBankColumns {
        static columnsKey = 'InitialData.PsConnectEdcBank';
    }
}
